/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} How_Page_Title_TailInputs */

const en_how_page_title_tail = /** @type {(inputs: How_Page_Title_TailInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`to your first new best.`)
};

const pl_how_page_title_tail = /** @type {(inputs: How_Page_Title_TailInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`do pierwszego rekordu.`)
};

/**
* | output |
* | --- |
* | "to your first new best." |
*
* @param {How_Page_Title_TailInputs} inputs
* @param {{ locale?: "en" | "pl" }} options
* @returns {LocalizedString}
*/
export const how_page_title_tail = /** @type {((inputs?: How_Page_Title_TailInputs, options?: { locale?: "en" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<How_Page_Title_TailInputs, { locale?: "en" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pl") return pl_how_page_title_tail(inputs)
	return en_how_page_title_tail(inputs)
});